import { useEffect, useState } from "react";

/**
 * Cross-fading photo carousel — advances every `interval` ms.
 * Falls back to a single image if only one photo is supplied.
 */
export default function PhotoCarousel({ photos = [], interval = 5000, className = "", alt = "" }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (photos.length < 2) return;
    const t = setInterval(() => setI((n) => (n + 1) % photos.length), interval);
    return () => clearInterval(t);
  }, [photos.length, interval]);

  if (photos.length === 0) return null;
  return (
    <div className={`relative overflow-hidden ${className}`}>
      {photos.map((src, idx) => (
        <img
          key={`${src}-${idx}`}
          src={src}
          alt={alt}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms] ${idx === i ? "opacity-100" : "opacity-0"}`}
        />
      ))}
      {photos.length > 1 && (
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
          {photos.map((_, idx) => (
            <button
              key={`dot-${idx}`}
              onClick={(e) => { e.preventDefault(); setI(idx); }}
              aria-label={`Go to photo ${idx + 1}`}
              className={`h-1 transition-all ${idx === i ? "w-6 bg-[#C9A96E]" : "w-2 bg-[#F5F1EA]/50 hover:bg-[#F5F1EA]/80"}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
